import React from "react";
import "../Layouts/AuthPagesLayout.css";
import Logo from "@images/poker-logo.png";

interface Props {
  children: React.ReactNode;
  heading: string;
}

const AuthPagesLayout: React.FC<Props> = ({ children, heading }) => {
  return (
    <section className="sign-up-section">
      <div className="main-sign-layout">
        <div className="parent-div">
          <div className="left-login-wrap">
            <div className="bg-img-div">
              <img alt="new-logo" className="logo-img" />
              <img alt="new-logo" className="new-logo-img" />
            </div>
          </div>
          <div className="right-content">
            <div className="sign-up-form">
              <div className="mobile-view-logo">
                <img src={Logo} alt="new-logo" className="eye-refer-logo" />
              </div>
              <div className="form-heading">
                <h2>{heading}</h2>
              </div>
              {children}
            </div>
          </div>
        </div>
        {/* <footer>@2024 Eye Refer</footer> */}
      </div>
    </section>
  );
};

export default AuthPagesLayout;
